import React from 'react';
import "./Notification.css";
import {LuAlertCircle} from "react-icons/lu";

function Notification({ type, children }: { type?: string; children: React.ReactNode }) {
    let icon = <LuAlertCircle className="notification-icon" />
  let className="Notification"
  if (type) {
    className += ` ${type}`;
    if (type === "warning") {
        icon = <LuAlertCircle className="notification-icon warning" />
    }
  }

  return (
    <div className={className}>
        {icon}
      {children}
    </div>
  );
}

export default Notification;